/**
 * Tag definitions and utilities
 * Migrated from frontend/src/TagsManager.tsx
 */

export const TAG_LABELS: Record<string, string> = {
  ':thumbs-up:': 'Thumbs up',
  ':thumbs-down:': 'Thumbs down',
  ':needs-review:': 'Needs review',
  ':reviewed:': 'Reviewed',
  ':finetuning:': 'Finetuning',
  ':example:': 'Example',
}

// Icons for tags (used in compact/icon-only mode)
export const TAG_ICONS: Record<string, string> = {
  ':thumbs-up:': '👍',
  ':thumbs-down:': '👎',
  ':needs-review:': '🔍',
  ':reviewed:': '✅',
  ':finetuning:': '⚙️',
  ':example:': '📝',
}

/**
 * Get icon for a tag
 */
export function getTagIcon(tag: string): string {
  return TAG_ICONS[tag] || '🏷️'
}

export interface Tag {
  id: string
  label: string
}

/**
 * Transform string tags to Tag objects with proper labels
 */
export function transformTags(tags: string[]): Tag[] {
  if (!Array.isArray(tags)) return []
  
  return tags.map((tag) => ({
    id: tag,
    label: TAG_LABELS[tag] || tag,
  }))
}

/**
 * Get display label for a tag
 */
export function getTagLabel(tag: string): string {
  return TAG_LABELS[tag] || tag
}

/**
 * Generate a consistent color from text (matching v1 algorithm)
 */
export function getColorFromTag(tag: string): string {
  const hash = Array.from(tag.toLowerCase()).reduce((acc, char) => {
    return char.charCodeAt(0) + ((acc << 5) - acc)
  }, 0)

  // Palette matching the v1 noteColors from theme.tsx
  const palette = [
    '#FC8077', // Coral
    '#368F8B', // Teal
    '#B3B8C8', // Deep Lavender
    '#D0BFD8', // Soft Lavender
    '#E0DFF0', // Pale Lavender
    '#91B6F2', // Classic Periwinkle
    '#BDC9E1', // Muted Periwinkle
    '#D6E3F7', // Light Periwinkle
    '#FFD1B3', // Pastel Peach
    '#FFC2CC', // Soft Blush Pink
    '#FFDDC1', // Light Apricot
  ]

  return palette[Math.abs(hash) % palette.length]
}
